import { Node } from '../class';

export class TextNode extends Node {
  public icon = 'font_download';
  public fontSize: string = '14';
  public text: string = '';
  public readonly extraProperties = ['fontSize', 'text'];
}
